/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { computed } from "@ember/object";
import { guidFor } from "@ember/object/internals";
import { tagName } from "@ember-decorators/component";
import selectKitPropUtils from "discourse/select-kit/lib/select-kit-prop-utils";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

@tagName("")
@selectKitPropUtils
export default class SelectedChoice extends Component {
  item = null;
  selectKit = null;
  extraClass = null;
  id = null;

  init() {
    super.init(...arguments);

    this.set("id", guidFor(this));
  }

  @computed("item")
  get itemValue() {
    return this.getValue(this.item);
  }

  @computed("item")
  get itemName() {
    return this.getName(this.item);
  }

  @computed("item")
  get mandatoryValuesArray() {
    return this.get("mandatoryValues")?.split("|") || [];
  }

  @computed("item")
  get readOnly() {
    if (typeof this.item === "string") {
      return this.mandatoryValuesArray.includes(this.item);
    }
    return this.mandatoryValuesArray.includes(this.item.id);
  }

  @computed("mandatoryValueTitle")
  get readOnlyTitle() {
    return (
      this.mandatoryValueTitle || i18n("admin.site_settings.mandatory_group")
    );
  }

  <template>
    {{#if this.readOnly}}
      <button
        class="btn btn-default disabled tag-choice"
        title={{this.readOnlyTitle}}
      >{{this.itemName}}</button>
    {{else}}
      <button
        aria-label={{i18n "select_kit.delete_item" name=this.itemName}}
        class="btn btn-default selected-choice tag-choice {{this.extraClass}}"
        data-name={{this.itemName}}
        data-value={{this.itemValue}}
        id="{{this.id}}-choice"
        type="button"
        {{on "click" (fn this.selectKit.deselect this.item)}}
      >
        {{dIcon "xmark"}}
        {{#if (has-block)}}
          {{yield}}
        {{else}}
          <span class="d-button-label">
            {{this.itemName}}
          </span>
        {{/if}}
      </button>
    {{/if}}
  </template>
}
